import { handleProductsSlider } from "../sliders/relatedProductsSlider";
import currency_symbols from "../utils/currencyCodes";

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

if ($(".template-product").length > 0) {
  const arr =
    $("#ymal-products").length > 0
      ? $("#ymal-products").data("ymal").split(", ")
      : [];
  const shuffledArray = shuffleArray(arr);
  const ymalProducts = shuffledArray.slice(0, 8);
  const products = [];

  const handleProducts = () => {
    $.when(
      ymalProducts.map((_product) => {
        return $.getJSON(`/products/${_product}`, function (_) {}).then(
          ({ product }) => {
            products.push(product);
          }
        );
      })
    );

    setTimeout(function () {
      if (products.length < 0) {
        return;
      } else {
        products.map((product, i) => {
          if (!product || typeof product === undefined) {
            return;
          }

          // Make sure the current product does not get listed
          if (window.location.pathname.includes(product.handle)) {
            return;
          }

          $("#ymal-slide").append(`
          <div>
            <div class="product-item-new">
              <div class="product-item__main">
                <a href="/products/${product.handle}">
                  <div class="product-item__image-wrap product-item__image-wrap--light">
                    <img class="product-item__image lazyload" data-src="${
                      product.image && product.image.src
                    }" alt="${product.image && product.image.alt}">
                    <img class="product-item__image lazyload" data-src="${
                      product.images[1] && product.images[1].src
                    }" alt="${product.images[1] && product.images[1].alt}">
                  </div>
                </a>
                <a href="#quickshop" class="js-modal-quickshop product-item__cta" data-product-handle="${
                  product.handle
                }" data-variant-id="${product.variants[0].id}">Quick View</a>
              </div>

              <div class="product-item__base">
                <a href="/products/${
                  product.handle
                }"><p class="product-item__name">${product.title}</p></a>
              </div>
              <div class="product-item__meta">
                <div class="product-item__price">
                  ${
                    window.Shopify.currency.active
                      ? currency_symbols[window.Shopify.currency.active]
                      : "£"
                  }
                  ${product.variants[0].price}
                </div>
              </div>
            </div>
            <a href="/products/${
              product.handle
            }" class="js-modal-quickshop product-item__link" data-product-handle="${
            product.handle
          }">Shop Now</a>
          </div>`);
        });
      }

      handleProductsSlider($("#ymal-slide"));
    }, 500);
  };

  handleProducts();
}
